import * as React from "react";
import type { SVGProps } from "react";
const SvgPassword02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6.529 9.302h.14m5.331 0h.14m5.19 0h.14m-6.07 5.4H4.533A2.133 2.133 0 0 1 2.4 12.57V6.036c0-1.178.955-2.134 2.133-2.134h14.934c1.178 0 2.133.956 2.133 2.134v3.266m-6.189 4.296 1.39-.696a3.6 3.6 0 0 1 3.22 0l1.39.696v3.344c0 1.156-1.068 1.935-3 3.156-1.932-1.22-3-2.25-3-3.155z"
    />
  </svg>
);
export default SvgPassword02;
